import { useEffect } from 'react';

import { usePublicApi as useCorePublicApi } from '@core/js/hooks/usePublicAPI/usePublicAPI';

import { useSunVegasPublicApi } from './sun/useSunVegasPublicApi';

export const usePublicApi = () => {
    useCorePublicApi();
    const sunVegasPublicApi = useSunVegasPublicApi();

    useEffect(() => {
        window.Playtech.API = {
            ...window.Playtech.API,
            ...sunVegasPublicApi
        };
    });
};
